export default __webpack_public_path__ + "static/media/Assistance.236ba12e.svg";